import React, { memo } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MessageSquareIcon, TrendingUpIcon, UserIcon, AwardIcon, ThumbsUpIcon, MessageCircleIcon, HashIcon, FlameIcon, TrophyIcon, UsersIcon, SearchIcon, PlusIcon, TagIcon } from 'lucide-react';
import { Sitemap } from '../components/Sitemap';
import { Link } from 'react-router-dom';
const FEATURED_DISCUSSIONS = [{
  title: {
    en: 'Tips for improving English pronunciation',
    ar: 'نصائح لتحسين نطق اللغة الإنجليزية'
  },
  author: 'Sarah Ahmed',
  avatar: 'https://i.pravatar.cc/150?img=1',
  date: '2 hours ago',
  dateAr: 'قبل ساعتين',
  likes: 24,
  replies: 12,
  tags: ['Pronunciation', 'Speaking'],
  trending: true,
  excerpt: {
    en: 'Here are some effective techniques I use to improve my English pronunciation...',
    ar: 'إليكم بعض التقنيات الفعالة التي أستخدمها لتحسين نطقي للغة الإنجليزية...'
  }
}, {
  title: {
    en: 'How to remember irregular verbs?',
    ar: 'كيف تتذكر الأفعال غير المنتظمة؟'
  },
  author: 'Mohammed Ali',
  avatar: 'https://i.pravatar.cc/150?img=2',
  date: '5 hours ago',
  dateAr: 'قبل 5 ساعات',
  likes: 18,
  replies: 8,
  tags: ['Grammar', 'Study Tips'],
  trending: false,
  excerpt: {
    en: 'I created a simple system to memorize irregular verbs easily...',
    ar: 'لقد ابتكرت نظامًا بسيطًا لحفظ الأفعال غير المنتظمة بسهولة...'
  }
}];
const TOP_CONTRIBUTORS = [{
  name: 'Ahmed Hassan',
  avatar: 'https://i.pravatar.cc/150?img=3',
  points: 1250,
  badge: 'Expert',
  badgeAr: 'خبير',
  contributions: 85
}, {
  name: 'Fatima Said',
  avatar: 'https://i.pravatar.cc/150?img=4',
  points: 980,
  badge: 'Advanced',
  badgeAr: 'متقدم',
  contributions: 64
}, {
  name: 'Omar Khaled',
  avatar: 'https://i.pravatar.cc/150?img=5',
  points: 750,
  badge: 'Regular',
  badgeAr: 'منتظم',
  contributions: 42
}];
const CATEGORIES = [{
  name: {
    en: 'Grammar Questions',
    ar: 'أسئلة القواعد'
  },
  count: 156,
  icon: HashIcon,
  description: {
    en: 'Get help with English grammar rules and structures',
    ar: 'احصل على المساعدة في قواعد اللغة الإنجليزية وتراكيبها'
  }
}, {
  name: {
    en: 'Speaking Practice',
    ar: 'ممارسة المحادثة'
  },
  count: 98,
  icon: MessageSquareIcon,
  description: {
    en: 'Practice conversations and pronunciation',
    ar: 'تدرب على المحادثات والنطق'
  }
}, {
  name: {
    en: 'Study Groups',
    ar: 'مجموعات الدراسة'
  },
  count: 45,
  icon: UsersIcon,
  description: {
    en: 'Join study groups and learn together',
    ar: 'انضم إلى مجموعات الدراسة وتعلم معاً'
  }
}];
const TRENDING_TAGS = ['Pronunciation', 'Grammar', 'Vocabulary', 'IELTS', 'Business English', 'Conversation'];
export function Community() {
  const {
    isArabic
  } = useLanguage();
  return <div className="w-full min-h-screen bg-gray-50 dark:bg-gray-900/50" data-id="element-2517">
      <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-2518">
        <Sitemap currentPage={{
        en: 'Learning Community',
        ar: 'مجتمع المتعلمين'
      }} breadcrumbs={[]} data-id="element-2519" />
        <div className="max-w-7xl mx-auto" data-id="element-2520">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-2521">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-2522">
              {isArabic ? 'مجتمع المتعلمين' : 'Learning Community'}
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-2523">
              {isArabic ? 'تواصل مع متعلمين آخرين، شارك تجربتك، واحصل على المساعدة' : 'Connect with fellow learners, share your experience, and get help'}
            </p>
          </div>
          {/* Search and Create Post */}
          <div className="flex flex-col md:flex-row gap-4 mb-8" data-id="element-2524">
            <div className="flex-1 relative" data-id="element-2525">
              <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" data-id="element-2526" />
              <input type="text" placeholder={isArabic ? 'ابحث في المجتمع...' : 'Search community...'} className="w-full pl-12 pr-4 py-3 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent transition-all duration-200" dir={isArabic ? 'rtl' : 'ltr'} data-id="element-2527" />
            </div>
            <button className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors" data-id="element-2528">
              <PlusIcon className="w-5 h-5" data-id="element-2529" />
              <span data-id="element-2530">{isArabic ? 'بدء نقاش جديد' : 'Start New Discussion'}</span>
            </button>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2531">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-8" data-id="element-2532">
              {/* Categories Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-2533">
                {CATEGORIES.map((category, index) => {
                const Icon = category.icon;
                return <div key={index} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 p-6 cursor-pointer" data-id="element-2534">
                      <div className="flex items-start gap-4" data-id="element-2535">
                        <div className="p-3 bg-blue-50 dark:bg-blue-900/30 rounded-lg" data-id="element-2536">
                          <Icon className="w-6 h-6 text-blue-600 dark:text-blue-400" data-id="element-2537" />
                        </div>
                        <div data-id="element-2538">
                          <h3 className="font-medium text-gray-900 dark:text-white mb-1" data-id="element-2539">
                            {isArabic ? category.name.ar : category.name.en}
                          </h3>
                          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2" data-id="element-2540">
                            {isArabic ? category.description.ar : category.description.en}
                          </p>
                          <div className="text-sm text-blue-600 dark:text-blue-400" data-id="element-2541">
                            {category.count}{' '}
                            {isArabic ? 'موضوع' : 'discussions'}
                          </div>
                        </div>
                      </div>
                    </div>;
              })}
              </div>
              {/* Featured Discussions */}
              <div data-id="element-2542">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-2543">
                  {isArabic ? 'النقاشات النشطة' : 'Active Discussions'}
                </h2>
                <div className="space-y-6" data-id="element-2544">
                  {FEATURED_DISCUSSIONS.map((discussion, index) => <div key={index} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 p-6" data-id="element-2545">
                      <div className="flex items-start gap-4" data-id="element-2546">
                        <img src={discussion.avatar} alt={discussion.author} className="w-10 h-10 rounded-full" data-id="element-2547" />
                        <div className="flex-1" data-id="element-2548">
                          <div className="flex items-center gap-2 mb-2" data-id="element-2549">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-2550">
                              {isArabic ? discussion.title.ar : discussion.title.en}
                            </h3>
                            {discussion.trending && <span className="flex items-center gap-1 text-sm text-orange-500" data-id="element-2551">
                                <FlameIcon className="w-4 h-4" data-id="element-2552" />
                                {isArabic ? 'رائج' : 'Trending'}
                              </span>}
                          </div>
                          <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400 mb-3" data-id="element-2553">
                            <span data-id="element-2554">{discussion.author}</span>
                            <span data-id="element-2555">•</span>
                            <span data-id="element-2556">
                              {isArabic ? discussion.dateAr : discussion.date}
                            </span>
                          </div>
                          <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-2557">
                            {isArabic ? discussion.excerpt.ar : discussion.excerpt.en}
                          </p>
                          <div className="flex flex-wrap gap-2 mb-4" data-id="element-2558">
                            {discussion.tags.map((tag, i) => <span key={i} className="px-3 py-1 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full text-sm" data-id="element-2559">
                                {tag}
                              </span>)}
                          </div>
                          <div className="flex items-center gap-4 text-gray-500 dark:text-gray-400" data-id="element-2560">
                            <button className="flex items-center gap-2 hover:text-blue-600 dark:hover:text-blue-400" data-id="element-2561">
                              <ThumbsUpIcon className="w-5 h-5" data-id="element-2562" />
                              <span data-id="element-2563">{discussion.likes}</span>
                            </button>
                            <button className="flex items-center gap-2 hover:text-blue-600 dark:hover:text-blue-400" data-id="element-2564">
                              <MessageCircleIcon className="w-5 h-5" data-id="element-2565" />
                              <span data-id="element-2566">{discussion.replies}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
            {/* Sidebar */}
            <div className="space-y-8" data-id="element-2567">
              {/* Community Stats */}
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6" data-id="element-2568">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6" data-id="element-2569">
                  {isArabic ? 'إحصائيات المجتمع' : 'Community Stats'}
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-2570">
                  <div className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg text-center" data-id="element-2571">
                    <div className="text-2xl font-bold text-blue-600 dark:text-blue-400" data-id="element-2572">
                      5.2K
                    </div>
                    <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2573">
                      {isArabic ? 'أعضاء' : 'Members'}
                    </div>
                  </div>
                  <div className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg text-center" data-id="element-2574">
                    <div className="text-2xl font-bold text-blue-600 dark:text-blue-400" data-id="element-2575">
                      892
                    </div>
                    <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2576">
                      {isArabic ? 'نقاش' : 'Discussions'}
                    </div>
                  </div>
                </div>
              </div>
              {/* Top Contributors */}
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6" data-id="element-2577">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6" data-id="element-2578">
                  {isArabic ? 'أفضل المساهمين' : 'Top Contributors'}
                </h3>
                <div className="space-y-6" data-id="element-2579">
                  {TOP_CONTRIBUTORS.map((contributor, index) => <div key={index} className="flex items-center gap-4" data-id="element-2580">
                      <img src={contributor.avatar} alt={contributor.name} className="w-10 h-10 rounded-full" data-id="element-2581" />
                      <div className="flex-1" data-id="element-2582">
                        <div className="font-medium text-gray-900 dark:text-white" data-id="element-2583">
                          {contributor.name}
                        </div>
                        <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2584">
                          {contributor.contributions}{' '}
                          {isArabic ? 'مساهمة' : 'contributions'}
                        </div>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2585">
                        <TrophyIcon className="w-4 h-4 text-yellow-500" data-id="element-2586" />
                        <span className="text-sm font-medium text-gray-600 dark:text-gray-300" data-id="element-2587">
                          {isArabic ? contributor.badgeAr : contributor.badge}
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>
              {/* Trending Tags */}
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6" data-id="element-2588">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6" data-id="element-2589">
                  {isArabic ? 'الوسوم الشائعة' : 'Trending Tags'}
                </h3>
                <div className="flex flex-wrap gap-2" data-id="element-2590">
                  {TRENDING_TAGS.map((tag, index) => <button key={index} className="px-3 py-1 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-full text-sm transition-colors" data-id="element-2591">
                      #{tag}
                    </button>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}